import React from "react"
import { StyleSheet, Text, View } from "react-native"
import { useSelector } from "react-redux"

import Base, { Firebase } from "../../base"
import { CustomSwitch } from "../common"
import OrdersHeaderButton from "../orders/OrdersHeaderButton"
import VenueNameBanner from "../orders/VenueNameBanner"

export default function SettingsHeader(props) {
  const services = useSelector(state => state.services)

  function onServiceChanged(index) {
    const service = services[index]
    props.onServiceChanged(service)
    Firebase.logEvent("service_" + service.key)
  }

  if (!props.service) {
    return <View />
  }

  return (
    <View style={styles.main}>
      {props.isMobile && <VenueNameBanner venue={props.venue} />}
      <View style={props.isMobile ? styles.categories : styles.categories_rg}>
        {services.map((service, index) => {
          let selected = props.service.key === service.key
          return (
            <OrdersHeaderButton
              selected={selected}
              onChanged={onServiceChanged}
              index={index}
              key={index}
              title={service.title}
              topLevel={true}
              isMobile={props.isMobile}
              pendingCount={props.pendingCount}
            />
          )
        })}
        {props.isMobile || (
          <View style={styles.flexContainer}>
            <View style={styles.flexContainer} />
            <Text style={styles.versionNumber}>
              {Base.functions.versionNumber()}
            </Text>
          </View>
        )}
      </View>
      {props.isMobile && (
        <View style={styles.switch}>
          <Text style={styles.switchTitle}>
            {"Enable " + props.service.title}
          </Text>
          <CustomSwitch
            value={props.service.isEnabled}
            onValueChange={() => props.onStatusChanged(props.service)}
            autoWidth
          />
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    backgroundColor: "white",
    alignItems: "center",
  },

  categories: {
    height: 48,
    flexDirection: "row",
  },

  categories_rg: {
    minWidth: 153,
    maxWidth: 153,
    flex: 1,
    borderColor: Base.colours.appSemiLightGrey,
    borderRightWidth: 2.0,
  },

  switch: {
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    height: 56,
    backgroundColor: "white",
    justifyContent: "space-between",
    paddingHorizontal: Base.constants.hmargin.sm,
  },

  switchTitle: {
    fontFamily: Base.fonts.appExtraBold,
    color: Base.colours.appDarkBlue,
    fontSize: 16,
    marginRight: 12,
  },

  versionNumber: {
    alignSelf: "center",
    marginVertical: 10,
  },

  flexContainer: { flex: 1 },
})
